export default __webpack_public_path__ + "static/media/include_14_male@2x.2035b897.jpg";